<template lang="pug">
  .d-case
    img.top-img(src="~assets/case/03/img1.png")
    .content
      .case-num Vol.03
      .case-title 上海175㎡暗黑系霸道总裁风，花100万装修只为这种feel
      .line1 有人喜欢把家装成北欧风，有人则喜欢“暗戳戳”的低调范，在属于你的家里，怎样都是合理的。
      .line1 今天窝仔要给大家介绍的客户陈小姐的家，她的家，绝非用“个性”二字可以形容。
      img.cont-img(src="~assets/case/03/img2.png")
      .cont-title 「背景信息」
      .line1 <span>关于屋主</span>陈小姐与先生也是家居领域的从商者，为了方便家里两个孩子上学，投入重金在上海黄浦区核心地段购置了这套学区房。由于职业背景缘故，两人对家居品位都有着非常高的审美与追求。
      .cont-title 「房子的基本信息」
      .line1
        <span>坐标：上海黄浦</span>
        <span>面积：175㎡</span>
        <span>户型：三室一厅</span>
      img.cont-img(src="~assets/case/03/img3.png")
      .line1 房子的原始状态是毛坯房，男主人偏爱暗黑系的霸道总裁风，简约大气又不乏精致感，为了呈现出满意的效果，装修前后耗时一年之久。
      .cont-title 玄关：简约摩登的气质
      .line1 进门入玄关，以通透的柜体遮挡区隔，视线可及客餐厅，有种犹抱琵琶半遮面的效果。男主人偏爱冷色调，大面积的黑白与玄关天花处暗藏的灯带，将气质定格在简约摩登。
      img.cont-img(src="~assets/case/03/img4.png")
      .line1 右手边是厨房，推拉门节省了空间。平时小孩在客厅玩，做饭的大人也能随时掌握他们的动向。
      img.cont-img(src="~assets/case/03/img2.png")
      .line1 墙面采用大面积深棕色木饰面，虽然被家里老人吐槽说太暗了，但却为整个空间奠定了沉稳大气的基调。
      img.cont-img(src="~assets/case/03/img6.png")
      .line1 隔断柜架的底部，也有隐藏灯带，让整个空间显得轻盈通透。上下灯带交相呼应，打造出自然柔和的照明效果。
      img.cont-img(src="~assets/case/03/img7.png")
      .line1 地面是大面积石砖，纹路清晰自然，水墨的意蕴从地面延伸到墙上，中和木饰面的暗色调，让玄关空间更加灵活有机。
      .cont-title 客餐厅：做足收纳，实用美观
      .line1
        <span>餐厅，处处体现细心</span>
        <span>经过玄关，右转来到餐厅。</span>
      img.cont-img(src="~assets/case/03/img8.png")
      .line1 这个空间的墙面依然是深色为主，吊顶和地面则是白色。
      img.cont-img(src="~assets/case/03/img9.png")
      .line1 餐厅的主角是一整套懂窝餐桌椅。蒙塔娜餐桌 有着北美橡木的原始粗犷，经擦色涂装工艺处理，呈现出独特的做旧风味，而桌腿则为实心铸铁打造，如枝干般遒劲有力。这种硬朗的工业风，与整个空间的气质相得益彰。
      img.cont-img(src="~assets/case/03/img10.png")
      .line1 一张蒙塔娜长凳跟餐桌配套，独特的燕尾榫成为富有巧思的点缀，两个小孩排排坐着吃饭，亲密无间又讨喜，是父辈想带给他们的快乐。
      img.cont-img(src="~assets/case/03/img11.png")
      .line1 同时搭配四张达希尔餐椅，造型纤细优雅，颜色材质和餐桌相匹配。
      img.cont-img(src="~assets/case/03/img12.png")
      .line1 餐厅左侧墙面有一个内嵌的置物台，可以放水壶、茶叶等物品，吃饭时还可以暂时放置碗盘，整个区域都保持着美而不乱，实用又好看。
      img.cont-img(src="~assets/case/03/img7.png")
      .line1 餐厅区收纳功能必不可少，餐桌后面是一整面储物柜，深色玻璃起到遮掩效果，减少了杂乱感。
      img.cont-img(src="~assets/case/03/img10.png")
      .cont-title 客厅，提升温馨感
      .line1 紧邻餐厅的就是客厅，相对其他区域显得很明亮。设计很简洁，以白、灰为主。
      img.cont-img(src="~assets/case/03/img15.png")
      .line1 这里是一家人活动的主要空间，增加了很多温馨的元素。比如沙发墙面采用浅灰色皮质软包，相比石材墙面，多了几分柔和。
      img.cont-img(src="~assets/case/03/img16.png")
      .line1 电视墙依然延续了大面积石材，与地面呼应，简洁耐看。窗外透进来的自然光，经墙面反射，让客厅区因此显得明亮通透。
      img.cont-img(src="~assets/case/03/img17.png")
      .line1 一张萨斯基亚地毯，为客厅的温馨感加分，低调的外观没有喧宾夺主，厚实柔软的触感，让这里成为小朋友们玩耍的最佳领地。
      img.cont-img(src="~assets/case/03/img18.png")
      .line1 沙发是现代风格的懂窝热卖款弗雷德里克窄扶手四人沙发，造型简洁大方，宽大舒适。定制的棉麻面料，既温馨，又结实耐用。
      img.cont-img(src="~assets/case/03/img19.png")
      .line1 房子是家的容器，承载了居住者的个性主张、兴趣与爱。这种暗黑系也是你喜欢的feel吗？欢迎留言告诉我们。
      .line1 看了这么多客户家，窝仔越发觉得，不管住在怎样的房子里，每个人都应该把对生活的热情投入到每一天，再平凡的日子，也能迸发出不平凡的精彩。
      .cont-title 装修巧思
      .line1 •  收纳柜门选用深色玻璃，弱化杂乱感，也方便找东西
      .line1 •  利用边角位置巧妙设计置物台，方便日常随手置物
      .line1 •  把卫生间的门“藏”进墙面，既美观又隐蔽
      .cont-title1  Q&A
      .line2 <span>Q：为什么选择懂窝的家具？</span>装完硬装后逛家具，碰巧看到懂窝的风格跟我家很搭，价格又合理，就选择懂窝了。
      .line2 <span>Q：在软装搭配方面有什么心得？</span>都是让懂窝的软装搭配师帮我搭配的，大件的床、沙发、地毯，小件的抱枕、茶几、灯，搭配在一起的效果都不错。
      .line2 <span>Q：花了多少钱装修？</span>从硬装到软装，前前后后总共花了一百万左右吧。
    img.scroll-top-btn(v-show="scrollTop", @click="backtop", src="~assets/goTop.png")
</template>

<script>
export default {
  data() {
    return {
      scrollTop: false
    }
  },
  mounted () {
    window.addEventListener("scroll", this.showbtn, true);
  },
  methods: {
    // 显示回到顶部按钮
    showbtn() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    /**
     * 回到顶部功能实现过程：
     * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
     * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
     * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
     * 4. 最后记得在移动到顶部时，清除定时器
     */
    backtop() {
      var timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  }
};
</script>

<style lang="sass" scoped>
@import 'config'
.d-case
  width: 100%
  position: relative
  padding-top: 0.1px
  .top-img
    width: 100%
    position: absolute
    z-index: -1
  .content
    margin: r(869) auto 0
    width: r(1020)
    // height: r(300)
    background: #ffffff
    padding-top: 0.1px
    padding-bottom: r(350)
    .case-num
      margin: r(43) auto
      width: r(844)
      font-family: PingFangSC-Regular
      font-size: r(20)
      color: #717273
      letter-spacing: 0
    .case-title
      margin: r(18) auto r(50)
      width: r(844)
      font-family: PingFangSC-Medium
      font-size: r(40)
      color: #070809
      line-height: r(60)
    .line1
      margin: r(30) auto
      width: r(844)
      font-family: PingFangSC-Medium
      font-size: r(20)
      color: #585858
      line-height: r(34)
      span
        display: block
        text-align: center
    .cont-img
      margin-top: r(60)
      width: 100%
    .cont-title
      margin-top: r(64)
      font-weight: bolder
      font-family: PingFangSC-Medium
      font-size: r(20)
      color: #070809
      text-align: center
    .cont-title1
      margin-top: r(110)
      font-family: PingFangSC-Medium
      font-size: r(20)
      color: #070809
      text-align: center
    .line2
      margin: r(31) auto 0
      width: r(844)
      font-family: PingFangSC-Medium
      font-size: r(20)
      color: #070809
      line-height: r(34)
      span
        display: block
        color: #000000
  .scroll-top-btn
    position: fixed
    z-index: 100
    bottom: r(100)
    right: r(100)
    width: r(80)
</style>



// WEBPACK FOOTER //
// case3.vue?7fe4ee31